import React, { useState } from "react";
import Module from "./Module";

const UnitSelector = ({
  defaultOpenModules = [],
  hideTagWhenOpen = false,
  modules = [],
  onSelect,
  type = "single",
}) => {
  const [openModules, setOpenModules] = useState(defaultOpenModules);
  const handleModuleSelect = (cmid) => {
    setOpenModules((state) => {
      const isOpen = state.some((s) => s === cmid);
      if (type === "single") {
        return isOpen ? [] : [cmid];
      }
      if (type === "multiple") {
        return isOpen ? state.filter((s) => s !== cmid) : [...state, cmid];
      }
      return state;
    });
  };
  return (
    <div className="h-full overflow-y-auto overflow-x-hidden">
      {modules.map((module) => (
        <Module
          key={module.cmid}
          hideTagWhenOpen={hideTagWhenOpen}
          module={module}
          onModuleSelect={() => handleModuleSelect(module.cmid)}
          onUnitSelect={onSelect}
          open={openModules.find((cmid) => module.cmid === cmid)}
        />
      ))}
      {modules.length === 0 && (
        <div className="p-2 text-sm text-gray-400">
          This course has no modules
        </div>
      )}
    </div>
  );
};

export default UnitSelector;
